import React, { useState } from "react";

// Popup "📖 Funzioni": raccoglie in un elenco cercabile le scorciatoie della
// tabella anteprima (Import Ordini), invece di un paragrafo fisso sempre a
// vista — con l'elenco destinato a crescere nel tempo, un testo lungo
// diventa presto illeggibile e difficile da scorrere. La ricerca filtra sia
// il titolo che la descrizione di ogni voce, così anche una parola sciolta
// (es. "maiuscolo") trova la funzione giusta senza dover ricordare
// l'etichetta esatta.
export const FUNZIONI_ANTEPRIMA_ORDINI = [
  { titolo: "Modifica una cella", testo: "Clicca e scrivi — utile soprattutto per le colonne \"Manuale\"." },
  { titolo: "Incolla un blocco copiato da Excel", testo: "Incollandolo su una cella si distribuisce da lì su righe e colonne successive." },
  { titolo: "\"↓ riempi\"", testo: "Nell'intestazione di una colonna: copia il valore della prima riga su tutte le altre." },
  { titolo: "\"AA\" / \"aa\"", testo: "Nell'intestazione di una colonna: mette tutta la colonna in MAIUSCOLO o minuscolo — utile se il file cliente non è uniforme." },
  { titolo: "⚠️ accanto al nome colonna", testo: "Segnala maiuscole/minuscole non uniformi in quella colonna (es. una riga \"MILANO\", un'altra \"milano\")." },
  { titolo: "🔢⚠️ accanto al nome colonna", testo: "Su colonne di soli codici numerici (es. \"24,71814\"), segnala righe con un numero di cifre diverso dal resto — evidenziate in rosso, spesso uno zero finale perso da Excel che rende il codice sbagliato per l'ERP." },
  { titolo: "\"🔤 Sviluppi\"", testo: "Sulla colonna Taglia_NomeSviluppo: le corrispondenze già note si applicano da sole, il pulsante serve solo per abbinare un valore mai visto prima a uno sviluppo già caricato (vocabolario gestito da wtrendy in Impostazioni)." },
  { titolo: "\"🔍 filtra...\"", testo: "Sotto ogni intestazione: mostra solo le righe dove quella colonna contiene il testo scritto — solo per cercare, non cambia cosa viene esportato/importato." },
  { titolo: "\"Solo righe da correggere\"", testo: "Mostra solo le righe con un codice sospetto (🔢⚠️), senza scorrere tutto il file." },
  { titolo: "Righe evidenziate in giallo", testo: "Hanno un campo obbligatorio vuoto o non valido (es. quantità a 0, rifiutata dall'API del gestionale)." },
  { titolo: "🗑️ a sinistra di una riga", testo: "Elimina quella riga." },
  { titolo: "\"Elimina righe senza campi obbligatori\"", testo: "Elimina tutte le righe con un campo obbligatorio mancante, in un colpo solo." },
];

// Stesso elenco, ma per la tabella di Revisione (Distinta Base/DDT) — vedi
// pages/Revisione.jsx, pulsante "📖 Funzioni".
export const FUNZIONI_REVISIONE = [
  { titolo: "Modifica una cella", testo: "Clicca e scrivi." },
  { titolo: "Incolla un blocco copiato da Excel", testo: "Incollandolo su una cella si distribuisce da lì su righe e colonne successive — utile per una colonna obbligatoria lasciata \"Manuale\" in Mapping (es. la Stagione, non presente nel file cliente ma uguale per tutta la distinta)." },
  { titolo: "\"↓ riempi\"", testo: "Nell'intestazione di una colonna: copia il valore della prima riga su tutte le altre." },
  { titolo: "\"AA\" / \"aa\"", testo: "Nell'intestazione di una colonna: mette tutta la colonna in MAIUSCOLO o minuscolo — utile se il file cliente non è uniforme." },
  { titolo: "⚠️ accanto al nome colonna", testo: "Segnala maiuscole/minuscole non uniformi in quella colonna (es. una riga \"MILANO\", un'altra \"milano\")." },
  { titolo: "🔢⚠️ accanto al nome colonna", testo: "Su colonne di soli codici numerici (es. \"24,71814\"), segnala righe con un numero di cifre diverso dal resto — evidenziate in rosso, spesso uno zero finale perso da Excel che rende il codice sbagliato per l'ERP." },
  { titolo: "\"Solo righe da correggere\" / \"✏️ Correggi codici\"", testo: "Il primo mostra solo le righe con un codice sospetto (🔢⚠️); il secondo li corregge in blocco, per valore invece che riga per riga." },
  { titolo: "\"🔍 filtra...\"", testo: "Sotto ogni intestazione: mostra solo le righe dove quella colonna contiene il testo scritto — solo per cercare, non cambia cosa viene esportato." },
  { titolo: "🧩⚠️ righe duplicate", testo: "Materiali \"duplicati esatti\": più righe con Codice Materiale, Descrizione, Codice/Descrizione Colore, UM e Consumo tutti identici — non è per forza un errore (può capitare con un consumo diverso per una parte diversa del prodotto finito), quindi non blocca l'export, ma alla richiesta di scarico viene chiesta conferma se ce ne sono ancora." },
  { titolo: "\"Solo righe duplicate\" / \"🧩 Righe duplicate\"", testo: "Il primo mostra solo le righe duplicate; il secondo apre lo strumento per vederle a gruppi ed eliminarle — singolarmente, tutte insieme, o tenendone solo una per materiale (\"✅ Mantieni solo una\")." },
  { titolo: "🗑️ a sinistra di una riga duplicata", testo: "Elimina quella riga." },
];

export default function LegendaFunzioniModal({ funzioni, onChiudi }) {
  const [ricerca, setRicerca] = useState("");

  const testo = ricerca.trim().toLowerCase();
  const filtrate = testo
    ? funzioni.filter((f) => (f.titolo + " " + f.testo).toLowerCase().includes(testo))
    : funzioni;

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "640px", maxWidth: "92vw", maxHeight: "84vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>📖</span>
            <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
              Funzioni della tabella
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "16px 22px 0" }}>
          <input
            type="text"
            autoFocus
            value={ricerca}
            onChange={(e) => setRicerca(e.target.value)}
            placeholder="🔍 Cerca una funzione (es. maiuscolo, filtra, elimina...)"
            style={{ width: "100%", boxSizing: "border-box" }}
          />
        </div>

        <div style={{ padding: "14px 22px 22px", overflowY: "auto" }}>
          {filtrate.length === 0 ? (
            <p className="testo-secondario" style={{ marginTop: "0.5rem" }}>Nessuna funzione trovata per "{ricerca}".</p>
          ) : (
            <ul style={{ margin: "0.5rem 0 0", paddingLeft: "1.2rem", display: "flex", flexDirection: "column", gap: "0.6rem" }}>
              {filtrate.map((f, i) => (
                <li key={i}>
                  <strong>{f.titolo}</strong>
                  <div className="testo-secondario">{f.testo}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
